import { Divider, Stack, Typography } from '@mui/material';

export function ProjectScoresDetailsTitle({ title }: { title: string }) {
  return (
    <Stack spacing={2} direction="row" alignItems={'center'} sx={{ mb: 2 }}>
      <Typography sx={{ fontSize: '1.5rem', fontWeight: '900', mt: 3 }}>
        {title}
      </Typography>
      <Divider sx={{ flexGrow: 1 }} />
    </Stack>
  );
}
